import { PlanTier } from '@shared/price-plan/enums';
import { PricePlan } from '@shared/price-plan/models';

export { FAVICON_ICONS } from './FAVICON_ICONS';
export * from './RESOURCE_ADJUSTMENT_ITEMS';
export * from './DYNAMICFIELDS';
export * from './email-regexp';
export * from './phone-regexp';

export const OLD_PLANS_LIMIT = 5000;
export const ENTERPRISE_LIMIT = 50000;
export const ONE_DAY_IN_MILLISECONDS = 86400000;
export const ENTERPRISE_PRICE_PLAN: PricePlan = {
  _id: 'id',
  default: false,
  description: '',
  enabled: true,
  href: '',
  name: 'Enterprise',
  plan_code: 'tablesready-premium-enterprise',
  plan_interval_length: 12,
  plan_interval_unit: 'month',
  subscribeHref: '',
  trial_interval_length: 0,
  trial_interval_unit: 'day',
  uuid: null,
  price: 1,
  limit: ENTERPRISE_LIMIT,
  outdated: false,
  availableForManager: true,
  tier: PlanTier.premium,
  partiesLimit: ENTERPRISE_LIMIT * 2,
};

export const USERNAME_PATTERN = /^[a-zA-Z0-9-_+.@']+$/;
// export const ACCOUNT_LOCATION_NAME_PATTERN = /^[a-zA-Z0-9+\/.,\-_!‘'%#$~&\\]([a-zA-Z0-9+\/.,\-_! ‘'%#$~&\\]*[a-zA-Z0-9+\/.,\-_!‘'%#$~&\\])?$/;
export const ACCOUNT_LOCATION_NAME_PATTERN = /^\S([\s\S]*\S)?$/;
export const NAME_PATTERN = /^[^0-9-_\s]{1}[\S ]+[^\s]{1}$/;
